const storageKey = 'channel-share-tips';

/** 查询标记 */
export const shouldShowTips = () => localStorage.getItem(storageKey) !== '1';

/** 进行标记 */
export const markShowTips = () => {
  localStorage.setItem(storageKey, '1');
};
